export default __webpack_public_path__ + "static/scientific-advancement-desktop-f5f6a871739ed74fd2832c2b0c5bb0f6.png";